import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FlashMessageErrorHandlerService {
    errorStack: any[] = [];
    errorSubject: BehaviorSubject<any> = new BehaviorSubject(null);
    errorDismissed: Subject<void> = new Subject<void>();
    constructor() {}
}
